import {connect} from 'react-redux';
import SideBar from './SideBar';

const mapStateToProps = ({
                           user: {
                             user: {attributes},
                             allowInspectionsShare,
                             firmInspectionsAccess
                           }
                         }) => ({
  allowInspectionsShare,
  firmInspectionsAccess,
  ...attributes,
});

export default connect(
  mapStateToProps,
  null
)(SideBar);
